/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2022-11-09 08:51:09
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2022-12-15 12:44:34
 * @FilePath: /wemeet-web-activity/src/pages/payend/component/ticket/index.tsx
 * @Description: pc长类型的票显示
 */
import { Button } from '@tencent/tea-component';
import React, { memo } from 'react';
// import { Data } from '@quickService/RegisterTicketQueryMyRegist';
// import LogoURL from 'src/assets/imgs/ticket-logo.svg';
import { activityTimeFormat } from "../BuyModal/utils/index";
import usePrice from "../PayEnd/hooks/usePrice";
import "./ps.modal.scss";
import BACN_NORMAL_ICON from "./imgs/back_normal.svg";
import CLOCK_ICON from "./imgs/clock.svg";
import getEnrollToken from "../quickServices/get-enroll-token";
import { getRequest, storage } from '@tencent/web-base';
import useLobbyType from "../BuyModal/hooks/useLobbyType";
/**
 * 从storage中获取lobby信息
 * @returns {object | null}
 */
export const getLobbyInfoFromStorage = () => {
  try {
    const value = JSON.parse(storage.useModule('events/lobby').useStorage('sessionStorage').getItem('lobby_meeting_info') || decodeURIComponent(getRequest('l_m_info') || '""') || '""');
    return value;
  } catch (error) {
    return null;
  }
};
const Ticket = ({
  ticketData,
  eventId,
  dataReport,
  http,
  onClickLaunch
}) => {
  const price = usePrice(ticketData);
  const lobbyInfo = getLobbyInfoFromStorage();
  const {
    lobbyLiveEnable
  } = useLobbyType({
    event_id: eventId
  }, http);
  return /*#__PURE__*/React.createElement("div", {
    className: "event-pc-long-ticket"
  }, /*#__PURE__*/React.createElement("div", {
    className: "event-pc-long-ticket-left"
  }, /*#__PURE__*/React.createElement("div", {
    className: "event-pc-long-ticket-left-hd"
  }, ticketData.ticket?.event_name), /*#__PURE__*/React.createElement("div", {
    className: "event-pc-long-ticket-left-dtl"
  }, /*#__PURE__*/React.createElement("img", {
    src: CLOCK_ICON,
    className: "svg-icon clock-icon"
  }), activityTimeFormat(ticketData.ticket?.first_scheduler_begin_time, ticketData.ticket?.last_scheduler_end_time)), /*#__PURE__*/React.createElement("div", {
    className: "event-pc-long-ticket-left-split"
  }), /*#__PURE__*/React.createElement("div", {
    className: "event-pc-long-ticket-left-footer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "event-pc-long-ticket-left-footer-t"
  }, /*#__PURE__*/React.createElement("div", {
    className: "t-name"
  }, ticketData.ticket?.ticket_name), ticketData.ticket?.ticket_code && /*#__PURE__*/React.createElement("div", {
    className: "t-dtl"
  }, "\u7968\u53F7 ", ticketData.ticket?.ticket_code)), /*#__PURE__*/React.createElement("div", {
    className: "t-price"
  }, price))), /*#__PURE__*/React.createElement("div", {
    className: "event-pc-long-ticket-right"
  }, /*#__PURE__*/React.createElement("div", {
    className: "event-pc-long-ticket-right-btns"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => {
      if (lobbyInfo) {
        if (lobbyInfo?.meetingId) {
          // 外场票
          if (ticketData?.ticket.ticket_auth_type === 1 && lobbyLiveEnable) {
            window.location.href = `${window.location.origin}/events/lobby/${eventId}/stage?meetingId=${lobbyInfo?.meetingId}`;
            return;
          }
          // 内场票唤起App并跳转到Lobby对应页面
          getEnrollToken({
            meeting_id: String(lobbyInfo?.meetingId)
          }, http).then(res => {
            if (res?.code === 0) {
              const query = `&tk=${encodeURIComponent(res?.data)}`;
              onClickLaunch?.(lobbyInfo?.meetingCode, lobbyInfo?.meetingUrl, true, query);
            }
          });
          if (lobbyInfo?.url) {
            window.location.href = lobbyInfo.url;
          }
        } else if (lobbyInfo?.url) {
          window.location.href = lobbyInfo.url;
        } else {
          window.location.href = `${window.location.origin}/events/lobby/${eventId}`;
        }
      } else {
        window.open(`${window?.origin}/events/my`, '_blank');
        dataReport('e#event_ticket_paid#ticket_check_button#click');
      }
    },
    type: "primary",
    className: "size-l size-full-width btn"
  }, lobbyInfo ? '进入活动' : '查看门票')), /*#__PURE__*/React.createElement("div", {
    className: "event-pc-long-ticket-right-info",
    onClick: () => {
      window.open(`${window?.origin}/events-lobby/my/ticket`, '_blank');
    }
  }, "\u95E8\u7968\u5DF2\u4FDD\u5B58\u5230\u7968\u5939", /*#__PURE__*/React.createElement("img", {
    src: BACN_NORMAL_ICON
  }))));
};
export default /*#__PURE__*/memo(Ticket);